<template src="./FormPage.html"></template>
<style src="./FormPage.scss" lang="scss"></style>
<script>
import FormIndexes from '@/components/FormIndexes/FormIndexes.vue'
import FormSidebar from '@/components/FormSidebar/FormSidebar.vue'
import FormStep1 from '@/components/FormStep1/FormStep1.vue'
import FormStep2 from '@/components/FormStep2/FormStep2.vue'
import FormStep3 from '@/components/FormStep3/FormStep3.vue'
import FormStep4 from '@/components/FormStep4/FormStep4.vue'
import FormStep5 from '@/components/FormStep5/FormStep5.vue'

export default {
    name: 'FormPage',

    data () {
        return {}
    },

    components: {
        'form-indexes': FormIndexes,
        'form-sidebar': FormSidebar,
        'form-step-1': FormStep1,
        'form-step-2': FormStep2,
        'form-step-3': FormStep3,
        'form-step-4': FormStep4,
        'form-step-5': FormStep5
    },

    computed: {
        form() {
            return this.$store.state.form
        },

        formIndex() {
            return this.$store.state.form.index
        },

        strings() {
            return this.$store.state.strings
        }
    },

    watch: {
        formIndex() {
            window.scrollTo(0, 0)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/FormPage/FormPage.vue